<template>
  <div>
    <basic-container>
       <avue-crud :option="option"
                  :data="list"
                  ref="crud"
                  v-model="form"
                  :table-loading="listLoading"
                  :before-open="handleOpenBefore"
                  @on-load="getList"
                  @row-update="update">
          
          <template slot="dailyLimit" slot-scope="scope" >
            {{scope.row.dailyLimit | dailyLimitFilter}}
          </template>

          <template slot-scope="scope" slot="menu">
            <el-button size="mini"
                       type="text"
                       icon="el-icon-edit"
                       v-if="rewardRule_btn_edit"
                       @click.native="handleUpdate(scope.row,scope.index)">编辑
            </el-button>
            <el-button size="mini"
                       type="text"
                       icon="el-icon-check"
                       v-if="rewardRule_btn_enable && !scope.row.isEnabled"
                       @click.native="handleEnable(scope.row,scope.index)">启用
            </el-button>
            <el-button size="mini"
                       type="text"
                       icon="el-icon-close"
                       v-if="rewardRule_btn_disable && scope.row.isEnabled"
                       @click.native="handleDisable(scope.row,scope.index)">禁用
            </el-button>
          </template>
       </avue-crud>
    </basic-container>
    <el-dialog
      title="编辑规则"
      :visible.sync="editRuleDialog"
      width="40%"
      class="handle-dialog">
        <el-form ref="rewardRuleFrom" :model="rewardRuleFrom" :rules="rules">
            <el-form-item prop="rewardValue">
              <el-label >积分值:</el-label>
                <el-input type="number" placeholder="请输入积分值(0或正整数)" v-model="rewardRuleFrom.rewardValue"></el-input>
            </el-form-item>
            <el-form-item prop="dailyLimit">
              <el-label >每日上限:</el-label>
                <el-input type="number" placeholder="请输入每日上限，-1表示无限制" v-model="rewardRuleFrom.dailyLimit"></el-input>
            </el-form-item>
            <el-form-item  prop="temp" v-if="rewardRuleFrom.additional">
              <el-label v-if="rewardRuleFrom.id === 4">获赞量:</el-label>
              <el-label v-else-if="rewardRuleFrom.id === 5">获收藏数:</el-label>
              <el-label v-else>条件</el-label>
                <el-input type="number" placeholder="请输入请输入九位以内的正整数" @blur="checkAdditional()" v-model="rewardRuleFrom.temp"></el-input>
            </el-form-item>
            <div class="handle-dialog-footer">
              <el-button type="primary" class="handle-dialog-footer-save" @click="update">确定</el-button>
              <el-button class="handle-dialog-footer-cancel" @click="closeDialogHandleRule">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import {enableRule,disableRule,getRewardRuleList,modifyRule} from '@/api/reward/rule'
  import {rewardRuleTypesEnum,rewardRuleKeyEnum} from '@/const/rewardRuleType';
  import {tableOption} from '@/const/crud/reward/rule';
  import {mapGetters} from 'vuex'

  export default {
    name: 'table_rule',
    data() {
      return {
        option: tableOption,
        list: [],
        form: {},
        listLoading: true,
        rewardRule_btn_edit: false,
        rewardRule_btn_enable: false,
        rewardRule_btn_disable: false,
        editRuleDialog: false,
        rewardRuleFrom: {
            id: undefined,
            actionDescription: '',
            additional: '',
            rewardValue: undefined,
            dailyLimit: undefined,
            temp: '',
        },
        rules: {
            rewardValue: [
              {
                required: true,
                message: '积分值不能为空',
                trigger: 'blur'
              },{
                pattern: /^-?[1-9]\d{0,8}$/,
                message: '请输入九位以内的整数',
                trigger: 'blur'
              }
            ],
            dailyLimit: [
              {
                required: true,
                message: '每日上限不能为空',
                trigger: 'blur'
              },{
                pattern: /^(-1|[1-9][0-9]{0,8})$/,
                message: '请输入九位以内的正整数,-1表示无限制',
                trigger: 'blur'
              }
            ]
        }
      }
    },
    filters: {
      dailyLimitFilter(val) {
        if( val === -1 ) return '无限制'
        else return val+'次'
      }
    },
    created() {
      this.rewardRule_btn_edit = this.permissions['reward_rule_edit']
      this.rewardRule_btn_enable = this.permissions['reward_rule_enable']
      this.rewardRule_btn_disable = this.permissions['reward_rule_disable']
    },
    computed: {
      ...mapGetters(['elements', 'permissions'])
    },
    methods: {
      getList() {
        this.listLoading = true
        getRewardRuleList().then(response => {
          var records = response.data.data
          if (records && records.length > 0) {
            records.forEach(function(record) {
              var condition = record.additional
              if (!condition) {
                record.condition = "--"
              }
              if (record.id === rewardRuleTypesEnum.POST_UPVOTE.code && condition){
                var obj = JSON.parse(condition)
                var str = '获得' + obj[rewardRuleKeyEnum.UPVOTE] + '个赞'
                record.condition = str
              }
              if (record.id === rewardRuleTypesEnum.POST_COLLECTED.code && condition){
                var obj = JSON.parse(condition)
                var str = '被收藏量达' + obj[rewardRuleKeyEnum.COLLECTION] + '个'
                record.condition = str
              }
            })
          }
          this.list = records
          this.listLoading = false
        })
      },
      closeDialogHandleRule() {
        this.editRuleDialog = false;
        this.$refs.rewardRuleFrom.clearValidate();
      },
      handleOpenBefore(show, type) {
        window.boxType = type;
        show();
      },
      handleUpdate(row, index) {
        this.editRuleDialog = true
        if(row.id === rewardRuleTypesEnum.POST_UPVOTE.code) {
            row.temp = JSON.parse(row.additional)[rewardRuleKeyEnum.UPVOTE]
        }
        if(row.id === rewardRuleTypesEnum.POST_COLLECTED.code) {
            row.temp = JSON.parse(row.additional)[rewardRuleKeyEnum.COLLECTION]
        }
        this.rewardRuleFrom = Object.assign({},row)
      },
      checkAdditional(){
        var rewardRuleFrom = this.rewardRuleFrom
        var reg = /^(0|[1-9][0-9]{0,8})$/
          if(rewardRuleFrom.id === rewardRuleTypesEnum.POST_UPVOTE.code) {
            if (!reg.test(rewardRuleFrom.temp)) {
              this.$message.error("请为获赞量设置一个整数")
              return false
            }
            rewardRuleFrom.additional = '{"' + rewardRuleKeyEnum.UPVOTE + '":"' + rewardRuleFrom.temp + '"}'
          }
          if(rewardRuleFrom.id === rewardRuleTypesEnum.POST_COLLECTED.code) {
            if (!reg.test(rewardRuleFrom.temp)) {
              this.$message.error("请为获收藏量设置一个整数")
              return false
            }
            rewardRuleFrom.additional = '{"' + rewardRuleKeyEnum.COLLECTION + '":"' + rewardRuleFrom.temp + '"}'
          }
          this.rewardRuleFrom = rewardRuleFrom
          return true
      },
      update() {
        var _this = this
        _this.$refs.rewardRuleFrom.validate((valid) => {
            if (!valid) return
            if(!_this.checkAdditional()) return 
            this.editRuleDialog = false;
            var rewardRuleFrom = _this.rewardRuleFrom
            modifyRule(rewardRuleFrom).then(() => {
                _this.getList()
                _this.$notify({
                    title: '成功',
                    message: '修改成功',
                    type: 'success',
                    duration: 2000
                  })
            })
        .catch(function () {});
        })
      },
      handleEnable(row) {
        var _this = this
        this.$confirm('是否确认启用名为"' + row.actionDescription + '"的奖励规则?', '启用', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          return enableRule(row.id)
        }).then(() => {
          this.getList()
          _this.$message({
            showClose: true,
            message: '启用成功',
            type: 'success'
          })
        }).catch(function () {
        })
      },
      handleDisable(row) {
        var _this = this
        this.$confirm('是否确认禁用名为"' + row.actionDescription + '"的奖励规则?', '禁用', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          return disableRule(row.id)
        }).then(() => {
          this.getList()
          _this.$message({
            showClose: true,
            message: '禁用成功',
            type: 'success'
          })
        }).catch(function () {
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
/deep/ .avue-crud__menu {
      display: none;
}
.handle-dialog {
  display: flex;
  flex-direction: column;
    &-footer{
      display: flex;
      flex-direction: row;
      padding: 50px 0px;
      &-save {
        padding: 8px 12px;
        position: absolute;
        right: 90px;
      }
      &-cancel {
        padding: 8px 12px;
        position: absolute;
        right: 10px;
        margin-right: 10px;
      }
    }
  }
</style>
